// export const API_Base_URL = "https://localhost:7065";
export const API_Base_URL = "https://vakrangee.demoo4s.com";
